import { z } from 'zod'

import { StudentIdSchema } from '~/@entities/Student'

/***************** 숙제 진행 상태 *****************/
export const HOMEWORK_STATUS = ['INCOMPLETE', 'PROGRESS', 'COMPLETE'] as const

// 학습 상태 어휘(LEARNING_STATUS)와 달리 서버의 StudentHomeworkStatus 에는 EXPIRED 가 없다.
export const HomeworkStatusSchema = z.enum(HOMEWORK_STATUS)
export type HomeworkStatus = z.infer<typeof HomeworkStatusSchema>

// 학생-학습지 목록(/student-worksheet/{studentId}/homeworks)이 품고 오는 숙제 한 건.
// 서버는 Asia/Seoul LocalDateTime 을 타임존 없이 내고, assignedDatetime 은 항상 있으며 완료 전이면 completeDatetime 이 null 이다.
export const HomeworkSchema = z.object({
  id: z.number(),
  studentId: StudentIdSchema,
  assignedDatetime: z.iso.datetime({ local: true }),
  completeDatetime: z.iso.datetime({ local: true }).nullable(),
  completed: z.boolean(),
  status: HomeworkStatusSchema,
  // 교재 숙제의 페이지 목록. 학습지 숙제는 null 이다.
  page: z.array(z.number()).nullable(),
})
export type Homework = z.infer<typeof HomeworkSchema>
